import React from 'react';
import PropTypes from 'prop-types';
import { Autocomplete as MUIAutocomplete, TextField } from '@mui/material';

Autocomplete.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  data: PropTypes.array,
  field: PropTypes.string.isRequired,
};

export default function Autocomplete({ label, value, onChange, data = [], field }) {
  const selectedOption = data.find((item) => item[field] === value) || null;

  return (
    <MUIAutocomplete
      options={data}
      getOptionLabel={(option) => option[field] || ''}
      value={selectedOption}
      onChange={(_, newValue) => {
        onChange(newValue ? newValue[field] : '');
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant='outlined'
          fullWidth
          sx={{
            '& .MuiInputBase-root': {
              paddingY: 0.5,
            },
          }}
        />
      )}
      isOptionEqualToValue={(option, val) => option[field] === val?.[field]}
    />
  );
}
